function properties() {
  return {
    userId: new URL(window.location.href).searchParams.get("userId"),
  };
}

function context() {
  return {
    integrations: {
      "Facebook Pixel": false,
      "Facebook Conversions API": false,
      "Facebook Offline Conversions": false,
    },
  };
}

export function page(pageName: string, pageProperties?: Record<string, unknown>) {
  analytics?.page(
    pageName,
    {
      ...pageProperties,
      ...properties(),
    },
    context(),
  );
}
